exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expense-status.pending[data-v-6de61551]{color:#f5b235}.expense-status.declined[data-v-6de61551]{color:#f53535}.expense-status.approved[data-v-6de61551]{color:#7ac914}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6de61551","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/office/expenses/RowComponent.vue
// module id = bEci
// module chunks = 0